import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InskicksResultatDetailsComponent } from './inskicks-resultat-details/inskicks-resultat-details.component';
import { AtgardsDetailsComponent } from './atgard-details/atgards-details.component';
import { LarmDetailsComponent } from './larm-details/larm-details.component';
import { LarmKriteriumDetailsComponent } from './larm-kriterium-details/larm-kriterium-details.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    InskicksResultatDetailsComponent,
    AtgardsDetailsComponent,
    LarmDetailsComponent,
    LarmKriteriumDetailsComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    InskicksResultatDetailsComponent,
    AtgardsDetailsComponent,
    LarmDetailsComponent,
    LarmKriteriumDetailsComponent,
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class DetailViewsModule {}
